import { discoveryTaskIds } from '@ipfabric/utils';
import { isValidRegExp } from 'utils/validation/isValidRegExp';
import z from 'zod';

const invalidRegexMsg = 'Invalid regex pattern';
export const missingRegexRuleMsg = 'At least 1 rule must be specified';

export const discoveryTasksRowDataSchema = z
  .object({
    id: z.string(),
    taskId: z.enum(discoveryTaskIds),
    label: z.string(),
    vendor: z.string().refine(isValidRegExp, invalidRegexMsg),
    family: z.string().refine(isValidRegExp, invalidRegexMsg),
    platform: z.string().refine(isValidRegExp, invalidRegexMsg),
    model: z.string().refine(isValidRegExp, invalidRegexMsg),
    version: z.string().refine(isValidRegExp, invalidRegexMsg),
    sn: z.string().refine(isValidRegExp, invalidRegexMsg),
  })
  .superRefine((data, ctx) => {
    const hasAnyRule = regexFields.some((field) => data[field].trim() !== '');
    if (!hasAnyRule) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: missingRegexRuleMsg,
        path: ['filters'],
      });
    }
  });

const regexFields = [
  'vendor',
  'family',
  'platform',
  'model',
  'version',
  'sn',
] as const satisfies (keyof z.infer<typeof discoveryTasksRowDataSchema>)[];

export type DiscoveryTasksRowData = z.infer<typeof discoveryTasksRowDataSchema>;
